import type { AltLangCode, LangCode, LangPath } from "./types.js";

export const langCodes: LangCode[] = [
    "en",
    "de",
    "es",
    "fr",
    "it",
    "pt",
    "nl",
    "ru",
    "ja",
    "ko",
    "zh-Hans",
    "zh-Hant",
];

export const altLangCodes: AltLangCode[] = langCodes.filter(
    (l): l is AltLangCode => l !== "en",
);

export const getLangPath = (langCode: LangCode): LangPath =>
    langCode === "en" ? "" : `/${langCode}`;
